import { put, call } from "redux-saga/effects";
import { videoHotlineConstants } from "../actions/constants/videoHotlineConstants";
import { VideoHotlineService } from "../services/api/videoHotlineService";
import { exceptionHandler } from "../pages/common/functions";

function* videoHotlineGetDetail(request: any) {
	try {
		const result = yield call(VideoHotlineService.videoHotlineGetDetail, request.input);
		var res = exceptionHandler(result);
		
		if (res.status) {
			yield put({
				type: videoHotlineConstants.VideoHotlineDetailSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: videoHotlineConstants.VideoHotlineDetailFailure, payload: res.data});
		}
	} catch (e) {
		yield put({ type: videoHotlineConstants.VideoHotlineDetailFailure, payload: e });
	}
}

function* videoHotlineGetByfilter(request: any) {
	try { 
		const result = yield call(VideoHotlineService.videoHotlineGetByfilter, request.input); 
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: videoHotlineConstants.VideoHotlineGetByfilterSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: videoHotlineConstants.VideoHotlineGetByfilterFailure, payload: res.data });
		}	
	} catch (e) {
		yield put({type: videoHotlineConstants.VideoHotlineGetByfilterFailure,payload: e});
	}
}

function* getMessageBoardID(request: any) {
	try {
		const result = yield call(VideoHotlineService.getMessageBoardID, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: videoHotlineConstants.GetMessageBoardIDSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: videoHotlineConstants.GetMessageBoardIDFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: videoHotlineConstants.GetMessageBoardIDFailure, payload: error });
	}
}

function* videoHotlineDelete(request: any) {
	try {
		const result = yield call(VideoHotlineService.videoHotlineDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: videoHotlineConstants.VideoHotlineDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: videoHotlineConstants.VideoHotlineDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: videoHotlineConstants.VideoHotlineDeleteFailure, payload: error });
	}
}

export const videoHotlineSaga = {
	videoHotlineGetDetail,
	videoHotlineGetByfilter,
	getMessageBoardID,
	videoHotlineDelete
}
